const customGenericClassNames = (ellipsis = true) =>
	`${ellipsis ? 'textEllipsis' : ''}`;

export { customGenericClassNames };